module.exports = __webpack_public_path__ + "img/praying into the ears of a taoist.16160e37.png";